import type { Property } from '@/modules/Properties/types';

export enum PageMappingType {
  URL_EQUALS = 'url_equals',
  URL_CONTAINS = 'url_contains',
  REGEX = 'regex',
  JAVASCRIPT = 'javascript',
}

export enum RuleOperator {
  OR = 'or',
  AND = 'and',
}

export interface PageMapping {
  id: string;
  type: PageMappingType;
  values: string[];
  propertyIds: string[];
  priority: number;
  regex?: string | null;
  javascript?: string | null;
  operator?: RuleOperator;
}

export interface Page {
  id: string;
  name: string;
  propertyIds?: string[];
  pages?: PageMapping[];
  /** UI-only field used for list reordering */
  priority?: number;
}

export interface PageGroupListItem {
  id: string;
  name: string;
  propertyIds: string[];
}

export interface PageGroupDetail {
  id: string;
  name: string;
  pages: PageMapping[];
}

export interface PageGroupWritePayload {
  id: string;
  name: string;
  pages: PageMappingApiPayload[];
}

export interface PageMappingApiPayload {
  id: string;
  type: PageMappingType;
  values: string[];
  propertyIds: string[];
  priority: number;
  regex?: string | null;
  javascript?: string | null;
  operator?: RuleOperator | null;
}

// Form view
export interface PageFormViewProps {
  pages: Page[];
  properties: Property[];
  saving: boolean;
  deleting: string;
  hasPropertyRestriction: boolean;
}
